import { Component, OnInit } from "@angular/core";
import moment from "moment-timezone";
import { AppService } from "src/app/core/services/app.service";
import { FocusdataService } from "src/app/core/services/focusdata.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { ImageCropperService } from "src/app/core/services/image-cropper.service";
import { UserService } from "src/app/core/services/user.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { AppMessageSeverity } from "src/app/shared/models/enums/AppMessageSeverity.enum";
import { EmployeeRecord } from "src/app/shared/models/focusDataModels/EmployeeRecord";
import { License } from "src/app/shared/models/license.model";
import { VenuePayDevicePreference } from "src/app/shared/models/VenuePayDevicePreferences.entity";

@Component({
	selector: "app-on-setup",
	templateUrl: "./on-setup.component.html",
	styleUrls: ["../../../commandcenter.scss"],
})
export class OnSetupComponent implements OnInit {
	changesToSave: boolean = false;

	employeeList: EmployeeRecord[];

	licenseList: License[];
	onDeviceSelected: License;

	moment: any = moment;

	timestamp;

	venuePayDevicePreferences: VenuePayDevicePreference;

	constructor(
		public app: AppService,
		private focuslink: FocuslinkService,
		private focusData: FocusdataService,
		public imgCrop: ImageCropperService,
		public venueService: OOVenueService,
		public userService: UserService
	) {}

	ngOnInit(): void {
		this.app.loading(true);
		this.timestamp = moment().unix();
		this.venueService.stationListGet(this.venueService.subscriptionVenue.value.key);

		this.licenseList = this.venueService.subscriptionVenue.value.licenses?.filter((i) => i.type === "on-device");
		this.venueOnDevicePreferenceGet(this.venueService.subscriptionVenue.value.key);
		this.employeeListGet(this.venueService.subscriptionVenue.value.key);
		this.app.loading(false);
	}

	async venueOnDevicePreferenceGet(venueKey: number) {
		const resp = await this.focuslink.onDeviceVenueConfigurationGet(venueKey);
		this.venuePayDevicePreferences = new VenuePayDevicePreference(resp);
	}

	async venueOnDevicePreferencePost(venueKey: number) {
		this.focuslink.onDeviceVenueConfigurationPost(venueKey, this.venuePayDevicePreferences);
	}

	async employeeListGet(venueKey) {
		const resp = await this.focusData.employeeList(venueKey, false);
		this.employeeList = resp.map((i) => new EmployeeRecord(i));
	}

	async deviceInfo(rec) {
		this.onDeviceSelected = rec;
	}

	onSave() {
		this.focuslink.onDeviceVenueConfigurationPost(this.venueService.subscriptionVenue.value.key, this.venuePayDevicePreferences);
		this.app.msgSvc.add({ severity: AppMessageSeverity.GREEN, summary: "", detail: `FocusON Settings Saved Successfully.` });
	}

	onImageComplete() {
		this.app.references.delay(1500);
		this.timestamp = moment().unix();
	}

	async selectImage(source) {
		this.imgCrop.openImageCropper(source, undefined, this.venueService.subscriptionVenue.value.key);
	}
}
